import { Table, TableColumnsType } from "antd";
import {
  BorrowerStatsTableTypes,
} from "../../../../components/Dashboards/Tables/Columns";
import { formatRupee } from "../../../../utils";
interface DpdBucketProps {
  data: any[];
  // loading: boolean;
}
const DpdBucket = ({ data }: DpdBucketProps) => {

  const totals = data?.reduce(
  (acc, curr) => {
    acc.totalBorrowers += curr.totalBorrowers || 0;
    acc.agentCallMade += curr.agentCallMade || 0;
    acc.whatsappSent += curr.whatsappSent || 0;
    acc.smsSent += curr.smsSent || 0;
    acc.dunningNotices += curr.dunningNotices || 0;
    acc.legalNotices += curr.legalNotices || 0;
    acc.mediationNotices += curr.mediationNotices || 0;
    acc.recoveryAmount += curr.recoveryAmount || 0;
    acc.monthTillDate += curr.monthTillDate || 0;
    acc.totalOSAmount += curr.totalOSAmount || 0;
    return acc;
  },
  {
    totalBorrowers: 0,
    agentCallMade: 0,
    whatsappSent: 0,
    smsSent: 0,
    dunningNotices: 0,
    legalNotices: 0,
    mediationNotices: 0,
    recoveryAmount: 0,
    monthTillDate: 0,
    totalOSAmount: 0,
  }
);


  const dailybaseColumns: TableColumnsType<BorrowerStatsTableTypes> = [
       {
      title: "No. Of Borrowers",
      dataIndex: "totalBorrowers",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Agent Calls Made",
      dataIndex: "agentCallMade",
      render: (value) => <span>{value ?? "-"}</span>,
    },
    // {
    //   title: "Dialer Calls",
    //   dataIndex: "dialerCallMade",
    //   render: (value) => <span>{value  ?? "-"}</span>,
    // },
    {
      title: "Whatsapp Sent",
      dataIndex: "whatsappSent",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "SMS Sent",
      dataIndex: "smsSent",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
      {
      title: "Dunning Notices",
      dataIndex: "dunningNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Legal Notices",
      dataIndex: "legalNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Mediation Notices",
      dataIndex: "mediationNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Recovered Amount",
      dataIndex: "recoveryAmount",
       render: (value) => <span>{formatRupee(value) ?? "-"}</span>,
    },
    {
      title: "MTD Collections (₹)",
      dataIndex: "monthTillDate",
       render: (value) => <span>{formatRupee(value) ?? "-"}</span>,
    },
    {
      title: "Outstanding Amount",
      dataIndex: "totalOSAmount",
      render: (value) => <span>{formatRupee(value) ?? "-"}</span>,
    },
  ];

  const dailyDpdTableColumn = [
    {
      title: "DPD BUCKET",
      dataIndex: "bucket",
      render: (value: any) => <span>{value || "-"}</span>,
    },
    ...dailybaseColumns,
  ];

  return (
    <div className="mt-10">
      <Table
        columns={dailyDpdTableColumn}
        dataSource={data || []}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
        rowKey={(record) => record.dpdBucket}
          summary={() => (
    <Table.Summary.Row style={{ fontWeight: 600 }}>
      <Table.Summary.Cell index={0}>
        TOTAL
      </Table.Summary.Cell>

      <Table.Summary.Cell index={1}>
        {totals?.totalBorrowers}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={2}>
        {totals?.agentCallMade}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={3}>
        {totals?.whatsappSent}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={4}>
        {totals?.smsSent}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={5}>
        {totals?.dunningNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={6}>
        {totals?.legalNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={7}>
        {totals?.mediationNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={8}>
        {formatRupee(totals?.recoveryAmount)}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={9}>
        {formatRupee(totals?.monthTillDate)}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={10}>
        {formatRupee(totals?.totalOSAmount)}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  )}
      />
    </div>
  );
};

export default DpdBucket;
